export const state = {
    interactionError: null,
    instanceToken: null,
    interactionInstance: null,
    interactionInstanceId: null,
    interactionSubInstances: null,
    interactionItems: null,
    currentItemNumber: 0,
    currentItem: null,
    currentItemMetaData: null,
    outcomeTaskInstance: null,
    outcomeTaskScenario: null,
    outcomeTaskScenarioInstance: null,
    colorVariant: 'bq-blue',
    requestError: null,
    itemLoading: false,
    isLoading: false,
    loadingState: null,
};

export const mutations = {
  SET_INTERACTION_TOKEN(state, payload) {
    state.instanceToken = payload
  },
  FETCH_INTERACTION_SUCCESS(state, payload) {
    // state.interactionSubInstances = null
    state.interactionInstance = payload
  },
  FETCH_INTERACTION_FAILURE(state, payload) {
    state.interactionError = payload
  },
  FETCH_SUB_INSTANCES_SUCCESS(state, payload) {
    state.interactionSubInstances = payload
  },
  FETCH_SUB_INSTANCES_FAILURE(state, payload) {
    state.interactionError = payload
  },
  START_SUB_INSTANCE_SUCCESS(state, payload) {
    state.instanceToken = payload
  },
  START_SUB_INSTANCE_FAILURE(state, payload) {
    state.interactionError = payload
  },
  FETCH_ITEMS_SUCCESS(state, payload) {
    state.interactionError = null
    state.interactionItems = payload
  },
  FETCH_ITEMS_FAILURE(state, payload) {
    state.interactionError = payload
  },
  UPDATE_ITEMS(state, payload) {
    state.interactionItems = payload
  },
  SET_CURRENT_ITEM_NUMBER(state, payload) {
    state.currentItemNumber = payload
  },
  FETCH_ITEM_METADATA_REQUEST(state, payload) {
    state.itemLoading = true
  },
  FETCH_ITEM_METADATA_SUCCESS(state, payload) {
    state.currentItemMetaData = payload
    state.itemLoading = false
  },
  FETCH_ITEM_METADATA_FAILURE(state, payload) {
    state.itemLoading = false
  },
  FETCH_OUTCOME_TASK_SUCCESS(state, payload) {
    state.outcomeTaskInstance = payload.instance
    state.outcomeTaskScenario = payload.scenario
    state.outcomeTaskScenarioInstance = payload.scenarioInstance
  },
  FETCH_OUTCOME_TASK_FAILURE(state, payload) {
  },
  ANSWER_OUTCOME_TASK_REQUEST(state, payload) {
    setLoadingState();
    state.requestError = null
  },
  ANSWER_OUTCOME_TASK_SUCCESS(state, payload) {
    if (payload !== 'FIN'){
      state.outcomeTaskScenarioInstance = payload
    }
    clearLoadingState();
  },
  ANSWER_OUTCOME_TASK_FAILURE(state, payload) {
    state.requestError = payload
    clearLoadingState();
  },
  ANSWER_ITEM_REQUEST(state, payload) {
    setLoadingState();
    state.requestError = null;
  },
  ANSWER_ITEM_SUCCESS(state, payload) {
    clearLoadingState();
  },
  ANSWER_ITEM_FAILURE(state, payload) {
    state.requestError = payload
    clearLoadingState();
  },
  SET_COLOR_VARIANT(state, payload) {
    state.colorVariant = payload
  },
  SET_INTERACTION_INSTANCE_ID(state, payload) {
    state.interactionInstanceId = payload
  }
};

function setLoadingState() {
  // clear any previous timer state which might be active
  if (state.loadingState !== null) {
    clearLoadingState();
  }
  state.loadingState = setTimeout(() => {
      state.isLoading = true
  }, 250);
}

function clearLoadingState() {
  clearTimeout(state.loadingState);
  state.isLoading = false;
  state.loadingState = null;
}
